var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-doc-canvas"},[(_vm.loaded && !_vm.preview)?_c('DocToolbar',{on:{"command":_vm.onCommand}}):_vm._e(),_c('iframe',{ref:"frame",staticClass:"mail-doc-canvas__frame",attrs:{"sandbox":"allow-same-origin","title":_vm.preview ? '메일 본문 미리보기' : '메일 본문 편집 캔버스'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }